// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type UpdateCurrentUserMutationVariables = Types.Exact<{
  input: Types.UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'User', id: string, name?: string | null, avatar?: Types.UserAvatar | null, preferredLanguage?: Types.UserPreferredLanguage | null, workspaceId: string, isPersonalWorkspace: boolean, workspace?: { __typename?: 'Workspace', id: string, name: string, ownerId: string } | null, availableWorkspaces: Array<{ __typename?: 'Workspace', id: string, name: string, ownerId: string, organizationId?: string | null, organizationName?: string | null, workspaceRole?: string | null, isReadOnly?: boolean | null, isPersonalWorkspace: boolean }> } };


export const UpdateCurrentUserDocument = gql`
    mutation UpdateCurrentUser($input: UpdateCurrentUserInput!) {
  updateCurrentUser(input: $input) {
    id
    name
    avatar
    preferredLanguage
    workspaceId
    isPersonalWorkspace
    workspace {
      id
      name
      ownerId
    }
    availableWorkspaces {
      id
      name
      ownerId
      organizationId
      organizationName
      workspaceRole
      isReadOnly
      isPersonalWorkspace
    }
  }
}
    `;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserMutation, { data, loading, error }] = useUpdateCurrentUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
      }
export type UpdateCurrentUserMutationHookResult = ReturnType<typeof useUpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationResult = ApolloReactCommon.MutationResult<UpdateCurrentUserMutation>;